import { useKeyboard, UseKeyboardLevel } from "@hubrise/react-components"
import * as React from "react"
import { useTranslation } from "react-i18next"

import { ToolButton } from "Catalog/shared/components/CatalogToolbar/Styles"

interface DeleteButtonProps<ItemType> {
  item?: ItemType | undefined
  handleDelete: (item: ItemType) => void
}

const DeleteButton = <ItemType,>({ item, handleDelete }: DeleteButtonProps<ItemType>): JSX.Element => {
  const { t } = useTranslation()

  const doDelete = () => {
    if (item !== undefined) handleDelete(item)
  }

  useKeyboard(UseKeyboardLevel.Main, { code: "Delete" }, doDelete, {
    isListening: Boolean(item),
    skipIfActiveElementEditable: true,
    description: "deleteModel",
  })

  return (
    <ToolButton icon="delete" onClick={doDelete} disabled={item === undefined}>
      {t("toolbar.delete")}
    </ToolButton>
  )
}

export default DeleteButton
